<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'参加パスワードの変更方法'">
        <template slot="content">
          <div class="text"><b>グループ管理</b>機能の<b>参加方法の設定</b>をタップして、参加パスワードの変更や参加者の範囲を設定することができます。</div>
          <img class="picture" src="../assets/images/features_admin/4.png">
          <img class="picture" src="../assets/images/features_admin/5.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesAdminChangeJoinPassword.vue